import { Select as AntdSelect } from 'antd';
import type { SelectProps } from 'antd';

export const Select: typeof AntdSelect = Object.assign(
  (props: SelectProps) => {
    const shouldEnableAutoClearSearchValue = props.mode === 'multiple' || props.mode === 'tags';

    return (
      <AntdSelect
        {...props}
        autoClearSearchValue={props.autoClearSearchValue ?? (shouldEnableAutoClearSearchValue ? true : undefined)}
      />
    );
  },
  AntdSelect
) as typeof AntdSelect;

export type { SelectProps };
